module.exports = __webpack_public_path__ + "img/novak.09e39087.jpg";